import customFetch from "../helpers/customFetch";
import { API_URL, URL_EXACTIAN, getConfigExactian } from "../helpers/helpers";

export const getAccessHoursService = async () => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/concept/AccessHours`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const getSystemDateAndHourService = async (format) => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${API_URL}accessHours?format=${format} `, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}